import React from 'react';
import PropTypes from 'prop-types';

import { Abstrap } from '../..';

const propTypes = {
    ...Abstrap.propTypes,
    disabled: PropTypes.bool,
    done: PropTypes.bool,
    icon: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
};

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'a',
    disabled: false,
    done: false,
};

class ProgressStep extends Abstrap {

    getClassNameSchema() {
        const {
            className,
            disabled,
            done,
        } = this.props;
        return [
            'c-progress-step',
            done ? 'c-progress-step--done' : '',
            disabled ? 'c-progress-step--disabled' : '',
            className,
        ];
    }

    render() {
        const {
            icon,
            text,
        } = this.props;
        return (
            <this.props.componentClass
                title={`Aller à l'étape : ${text}`}
                /* eslint-disable-next-line react/jsx-props-no-spreading */
                {...this.filterProps()}
                className={this.getClassName()}
            >
                <div className="c-progress-step__icon">
                    {icon}
                </div>
                <div className="c-progress-step__text">
                    {text}
                </div>
            </this.props.componentClass>
        );
    }

}

ProgressStep.propTypes = propTypes;

ProgressStep.defaultProps = defaultProps;

export default ProgressStep;
